import { ConfigFn } from '@config/types'

const config = (({ staticAssetPageUrl, staticPageUrlSuffix }) =>
  ({
    staticPageUrl: `${staticAssetPageUrl}/infogram${staticPageUrlSuffix}?id=`,
  }) as const) satisfies ConfigFn

export default config
